/* src/app/shared/components/dda-modal/dda-modal.component.scss */
:host {
  display: block;
  box-sizing: border-box;
  width: 612px;
  min-height: 450px;
  max-width: calc(100vw - 32px);
  padding: 32px 24px 24px;
}
:host:has(.dda-result-state) {
  min-height: unset;
}
.dda-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 400px;
  text-align: center;
}
.dda-description {
  max-width: 476px;
  margin: 0 0 40px;
  color: var(--cds-text-medium);
  font-size: 16px;
  line-height: 24px;
}
.dda-label {
  width: 100%;
  max-width: 376px;
  text-align: left;
  color: var(--cds-text-strong);
  font-size: 16px;
  font-weight: 600;
}
cds-checking-account-dropdown {
  width: 100%;
  max-width: 376px;
  margin-bottom: 40px;
}
cds-checking-account-dropdown ::ng-deep .bank-title h6 {
  line-height: 1.35;
}
cds-checking-account-dropdown ::ng-deep .bank-title small {
  line-height: 1.35;
}
.dda-account-shimmer {
  width: 100%;
  max-width: 376px;
}
.dda-footnote {
  max-width: 512px;
  margin: 0 0 40px;
  color: var(--cds-text-medium);
  font-size: 14px;
  line-height: 20px;
}
.dda-result-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 14px;
}
.status-icon {
  font-size: 50px;
}
.status-icon.success {
  color: var(--cds-revenue);
}
.status-icon.error {
  color: var(--cds-primary-500);
}
.result-title {
  margin: 0;
  color: var(--cds-text-strong);
  font-size: 22px;
  font-weight: 700;
}
.result-description {
  margin: 0 0 8px;
  color: var(--cds-text-medium);
  font-size: 16px;
  line-height: 24px;
}
button.cds-button.s-solid {
  margin-bottom: 16px;
}
.dda-config-link {
  max-width: 476px;
  margin: 0 0 16px;
  padding: 0;
  border: none;
  background: none;
  color: var(--cds-primary-500);
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
}
@media (max-width: 768px) {
  :host {
    width: 100%;
    min-height: auto;
    padding: 20px;
  }
  .dda-modal-content,
  .dda-result-state {
    min-height: auto;
  }
}
/*# sourceMappingURL=dda-modal.component.css.map */
